import * as types from "@/store/mutationTypes";

export const mutations = {
    [types.SET_CUSTOM_FORM](state, payload) {
        const isExist = state.forms.find(el => el.formId === payload.formId);
        const customForm = payload.customForms.find(el => el.id === payload.formId)
        if(!isExist) {
            const answerForm = {
                childId: payload.childId,
                activityId: payload.activityId,
                activityType: payload.activityType,
                formId: payload.formId,
                answers: []
            };
            customForm.formFields.forEach(item => {
                const answerField = {
                    formFieldId: item.id,
                    answer: ''
                }
                answerForm.answers.push(answerField);
            })
            state.forms.push(answerForm);
        }
    },

    [types.SET_CUSTOM_FORM_ANSWER](state, payload) {
        const customForm = state.forms.find(form => form.formId === payload.formId);
        customForm.answers.forEach((el, index) => {
            if (el.formFieldId === payload.id) {
                if(Array.isArray(payload.answer)) {
                    el.answer = payload.answer.join(',');
                } else {
                    el.answer = payload.answer
                }
            }
        })
    },

    [types.CLEAN_CUSTOM_FORM](state) {
        state.forms = [];
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/customForm/mutations.js